import React from "react";

const ContactWhats = ({ children }) => {
    return (
        <a
            // new number +966 56 969 1027
            href="https://api.whatsapp.com/send/?phone=966569691027"
            aria-label="تواصل معنا عبر واتساب"
            target="_blank"
        >
            {children}
        </a>
    );
};

export default ContactWhats;
